/* Millimili 3.0 — koleksiyon araç çubuğu davranışı. Sahibi: koleksiyon ajanı.
 * Markup: sections/main-collection-product-grid.liquid (.mm3-tb), snippets/filter-mm3-inline*.liquid, filter-mm3-sort.liquid
 * Araç çubuğu #ProductGridContainer içinde; facets.js filtre değişince onu yeniden çizer → her şey belge düzeyinde dinlenir.
 *  - satır içi filtre açılırları: tek seferde bir tane açık; dışarı tıklama / Escape kapatır (odak düğmeye döner)
 *  - seçenek bağlantıları ve fiyat formu: FacetFiltersForm varsa sayfa yenilenmeden uygulanır, yoksa normal gezinme
 *  - 2/4 sütun seçici (≥1200 px): tercih tarayıcıda (localStorage) saklanır
 *  - Filter düğmesi aria-expanded, çekmecenin açık/kapalı durumunu izler
 *  - sıralama listesi: Enter/Space ile seçim (Wonder'da yalnız fare)
 */
(() => {
  if (window.__mm3Collection) return;
  window.__mm3Collection = true;

  const KEY = "mm3-grid-cols";
  const store = {
    get() {
      try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
    },
    set(v) {
      try { window.localStorage.setItem(KEY, v); } catch (e) { /* özel pencere vb. */ }
    },
  };

  /* ---------- satır içi filtreler ---------- */
  const openPanels = () => document.querySelectorAll("[data-mm3-if-btn][aria-expanded='true']");
  function closeAll(except) {
    openPanels().forEach((btn) => {
      if (btn === except) return;
      btn.setAttribute("aria-expanded", "false");
      const panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (panel) panel.hidden = true;
    });
  }
  function toggle(btn) {
    const panel = document.getElementById(btn.getAttribute("aria-controls"));
    if (!panel) return;
    const open = btn.getAttribute("aria-expanded") === "true";
    closeAll(btn);
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    panel.hidden = open;
    if (!open) {
      // panel sağ kenardan taşmasın
      panel.style.left = "";
      panel.style.right = "";
      const r = panel.getBoundingClientRect();
      if (r.right > window.innerWidth - 16) {
        panel.style.left = "auto";
        panel.style.right = "0";
      }
    }
  }

  function applyUrl(href) {
    const url = new URL(href, window.location.href);
    if (typeof FacetFiltersForm !== "undefined" && typeof FacetFiltersForm.renderPage === "function" && url.pathname === window.location.pathname) {
      closeAll();
      FacetFiltersForm.renderPage(url.searchParams.toString());
      return true;
    }
    return false;
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-mm3-if-btn]");
    if (btn) {
      e.preventDefault();
      toggle(btn);
      return;
    }
    const link = e.target.closest("[data-mm3-if-link]");
    if (link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (applyUrl(link.href)) e.preventDefault();
      return;
    }
    if (!e.target.closest("[data-mm3-if]")) closeAll();

    const col = e.target.closest("[data-mm3-col]");
    if (col) {
      setCols(col.dataset.mm3Col, true);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const open = openPanels()[0];
      if (open) {
        closeAll();
        open.focus();
      }
      return;
    }
    // role=checkbox bağlantılar: Space de seçer
    if (e.key === " " && e.target.matches && e.target.matches("[data-mm3-if-link][role='checkbox']")) {
      e.preventDefault();
      e.target.click();
      return;
    }
    // Wonder sıralama listesi: Enter / Space
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".mm3-sort [custom-select-list] li[value]")) {
      e.preventDefault();
      e.target.click();
    }
  });

  document.addEventListener("submit", (e) => {
    const form = e.target.closest && e.target.closest("[data-mm3-if-price]");
    if (!form) return;
    const params = new URLSearchParams(new FormData(form));
    // boş alanları gönderme
    ["filter.v.price.gte", "filter.v.price.lte"].forEach((k) => {
      if (params.get(k) === "") params.delete(k);
    });
    const href = `${form.getAttribute("action") || window.location.pathname}?${params.toString()}`;
    if (applyUrl(href)) e.preventDefault();
  });

  /* ---------- 2/4 sütun ---------- */
  // 2 sütunda kart 1440'ta 672 px, banner tam genişlik (1360). Liquid'deki sizes 4 sütuna göre (25vw / 47vw) →
  // tarayıcı 375w dosyayı büyütüyordu. 2 sütun yalnız ≥1200 px'te geçerli, bu yüzden başa yalnız o kırılımın
  // koşulu eklenir; 4 sütuna dönünce aynı önek silinir (durumsuz, yeni gelen kartlarda da aynı işlem).
  const SIZES_2 = { card: "(min-width: 1200px) 50vw, ", banner: "(min-width: 1200px) 95vw, " };
  function applySizes(grid) {
    if (!grid) return;
    const two = grid.getAttribute("data-mm3-cols") === "2";
    grid.querySelectorAll("img[sizes]").forEach((img) => {
      const pre = img.classList.contains("mm3-gb__img") ? SIZES_2.banner : SIZES_2.card;
      const s = img.getAttribute("sizes") || "";
      const has = s.startsWith(pre);
      if (two && !has) img.setAttribute("sizes", pre + s);
      else if (!two && has) img.setAttribute("sizes", s.slice(pre.length));
    });
  }
  const watched = new WeakSet();
  function watchGrid(grid) {
    // Load more / facets yeni kart ekleyince onlara da uygula
    if (!grid || watched.has(grid) || !("MutationObserver" in window)) return;
    watched.add(grid);
    new MutationObserver(() => applySizes(grid)).observe(grid, { childList: true });
  }
  function setCols(n, save) {
    const grid = document.getElementById("product-grid");
    const v = n === "2" ? "2" : "4";
    if (grid) {
      grid.setAttribute("data-mm3-cols", v);
      applySizes(grid);
      watchGrid(grid);
    }
    document.querySelectorAll("[data-mm3-col]").forEach((b) =>
      b.setAttribute("aria-pressed", b.dataset.mm3Col === v ? "true" : "false"),
    );
    if (save) store.set(v);
  }
  const restoreCols = () => {
    if (!document.querySelector("[data-mm3-cols]")) return;
    const saved = store.get();
    setCols(saved === "2" ? "2" : "4", false);
  };

  /* ---------- Filter düğmesi aria-expanded ---------- */
  function syncFilterButton() {
    const drawer = document.querySelector(".wt-filter--drawer");
    const openState = !!drawer && drawer.classList.contains("wt-filter--drawer-open");
    document.querySelectorAll(".mm3-tb__filter").forEach((b) => b.setAttribute("aria-expanded", openState ? "true" : "false"));
  }

  function init() {
    restoreCols();
    syncFilterButton();
    const drawer = document.querySelector(".wt-filter--drawer");
    if (drawer && "MutationObserver" in window) {
      new MutationObserver(syncFilterButton).observe(drawer, { attributes: true, attributeFilter: ["class"] });
    }
    const container = document.getElementById("ProductGridContainer");
    if (container && "MutationObserver" in window) {
      new MutationObserver(() => {
        restoreCols();
        syncFilterButton();
      }).observe(container, { childList: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
